<template>
  <table
    class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
      <tr>
        <td colspan="4">
          Vulnerabilidade(s):
          <img
            src="/img/load.svg"
            style="max-height: 20px"
            v-if="loadingVulnerabilidades"
          />
          <span
            v-else
            class="d-inline mr-2 text-bold"
            v-for="vulnerabilidade in vulnerabilidades"
          >
            - {{ vulnerabilidade.value }}
          </span>
        </td>
      </tr>
      <tr>
        <td>
          Constituição Familiar Atual:
          <span v-if="item.constituicao">
            <b>
              {{
                $root.arrays.constituicao.filter((el) => {
                  return el.id == item.constituicao;
                })[0]["value"]
              }}
            </b></span
          >
        </td>
        <td>
          FAMÍLIA EM SITUAÇÃO DE RUA?
          <span v-if="item.situacao_rua">
            <b>
              {{
                $root.arrays.pergunta.filter((el) => {
                  return el.id == item.situacao_rua;
                })[0]["value"]
              }}
            </b></span
          >
        </td>
      </tr>
      <tr>
        <td>
          Trabalho infantil na família?
          <span v-if="item.trabalho_infantil">
            <b>
              {{
                $root.arrays.pergunta.filter((el) => {
                  return el.id == item.trabalho_infantil;
                })[0]["value"]
              }}
            </b></span
          >
        </td>
        <td>
          FOI ATINGIDA POR SITUAÇÕES DE EMERGÊNCIA OU ESTADO DE CALAMIDADE
          PÚBLICA?
          <span v-if="item.catastrofe">
            <b>
              {{
                $root.arrays.pergunta.filter((el) => {
                  return el.id == item.catastrofe;
                })[0]["value"]
              }}
            </b></span
          >
        </td>
      </tr>
      <tr>
        <td colspan="4">
          Família migrante?
          <span v-if="item.migrante">
            <b>
              {{
                $root.arrays.pergunta.filter((el) => {
                  return el.id == item.migrante;
                })[0]["value"]
              }}
            </b>

            <div class="d-inline">
              Origem: <b>{{ item.origem_migrante }}</b>
            </div>
            <div class="d-inline">
              Destino: <b> {{ item.destino_migrante }}</b>
            </div>
          </span>
        </td>
      </tr>
      <tr>
        <td colspan="4">
          Família composta por membro(s) LGBTQIAPN+?
          <span v-if="item.familia_lgbtqia">
            <b>
              {{
                $root.arrays.pergunta.filter((el) => {
                  return el.id == item.familia_lgbtqia;
                })[0]["value"]
              }}
            </b></span
          >
        </td>
      </tr>
      <tr>
        <td colspan="4">
          Caso o grupo familiar, em seu conjunto, já tenha vivenciado alguma
          situação de acolhimento institucional (abrigamento) decorrente da
          perda, temporária ou definitiva, do domicílio, quer em função de
          catástrofe natural ou de fatalidade pessoal, registre o período em que
          o fato ocorreu e o motivo/fato que levou ao acolhimento.
          <b>{{ item.obs_acolhimento }}</b>
        </td>
      </tr>
      <tr>
        <td colspan="4">
          Caso alguma criança/adolescente da família esteja, ou já tenha estado,
          sob guarda (legal ou informal) de outra pessoa não residente no
          domicílio (família extensa, amigos, patrões etc). registre o período
          em que o fato ocorreu, a razão pela qual ocorreu, a pessoa que esteve
          com a guarda e o nome da criança/adolescente.
          <b>{{ item.obs_guarda }}</b>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["item", "loading"],
  data() {
    return {
      vulnerabilidades: [],
      loadingVulnerabilidades: false,
    };
  },
  mounted() {
    this.getVulnerabilidades();
  },
  methods: {
    getVulnerabilidades() {
      this.loadingVulnerabilidades = true;
      axios.get(`api/dashboard/get/geral/vulnerabilidades`).then((response) => {
        this.vulnerabilidades = response.data.filter((el) =>
          this.item.vulnerabilidades.includes(el.id)
        );
        this.loadingVulnerabilidades = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
